/**
 * @module app.NotifyNotificationType
 */
/**
 * @enum {string}
 */
const exports = {
  INFO: 'alert-info',
  WARNING: 'alert-warning',
  ERROR: 'alert-danger'
};


export default exports;
